
























import { Component, Vue } from 'vue-property-decorator';
import { Getter, Action } from 'vuex-class';
import ActivityLabel from '@/components/common/edit/ActivityLabel.vue';
import getUrlParam from '@/common/utils/getUrlParam';
import Bridge from '@/common/bridge';
import moment from 'moment';
import getActivityType from '@/common/utils/getActivityType';
interface Payload {
  deadline?: number;
}

@Component({
  components: {
    'activity-label': ActivityLabel
  }
})
export default class ActivityDeadline extends Vue {
  @Getter('deadline') getterDeadline: any;
  @Getter('section') section: any;
  @Getter('startTime') startTime: any;
  @Getter('supportPay') supportPay: any;
  @Getter('channel') channel: any;
  @Getter('canPay') canPay!: boolean;
  @Getter('releaseStatus') releaseStatus: any;

  @Action('changeDeadline') changeDeadline!: Function;
  @Action('changeShowFooter') changeShowFooter!: Function;

  showDatePicker: boolean = false;
  type: string = getUrlParam('type') as string;
  isCopy: boolean = getUrlParam('state') == 'copy';

  get deadlineStyle() {
    return {
      color: this.section.inputFontColor,
      backgroundColor: this.section.inputBackgroundColor
    };
  }

  get deadline(): number {
    return this.getterDeadline;
  }
  get setDeadTimeState(): boolean {
    if (this.channel !== 'XM_CASHIER' && this.supportPay  && this.type === 'reEdit') {
      return false;
    } else if (this.channel !== 'XM_CASHIER' && this.supportPay && this.type === 'edit' && this.releaseStatus === 0&&!this.isCopy) {
      return false;
    }
    return true;
  }

  set deadline(val: number) {
    const payload: Payload = {
      deadline: val
    };
    this.changeDeadline(payload);
  }

  mounted() {
    this.isCopy &&
      setTimeout(() => {
        const payload: Payload = {
          deadline: moment()
            .startOf('day')
            .add(14, 'day')
            .add(23, 'hour')
            .valueOf()
        };
        this.changeDeadline(payload);
      }, 2000);
  }

  handleShow() {
    if (!this.setDeadTimeState) {
      return;
    }
    this.showDatePicker = true;
    this.changeShowFooter(false);
  }
  handleSetDeadline(value: number) {
    this.deadline = value;
    this.changeShowFooter(true);
  }
  handleCancle() {
    this.changeShowFooter(true);
  }
}
